<template>
  <section class="d-grid gap-4">
    <header class="d-flex justify-content-between align-items-start flex-wrap gap-3">
      <div>
        <h2 class="h4 mb-1">Timbrados</h2>
        <p class="text-muted mb-0">Catálogo de timbrados disponibles para facturación electrónica.</p>
      </div>
      <button class="btn btn-outline-dark btn-sm" @click="loadRows" :disabled="loading">Recargar</button>
    </header>

    <div class="card shadow-sm">
      <div class="card-body">
        <form class="row g-3" @submit.prevent="saveRow">
          <div class="col-md-3">
            <label class="form-label">Número timbrado</label>
            <input v-model="form.numero_timbrado" class="form-control" type="text" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Fecha inicio</label>
            <input v-model="form.fecha_inicio" class="form-control" type="date" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Fecha fin</label>
            <input v-model="form.fecha_fin" class="form-control" type="date" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Activo</label>
            <select v-model="form.activo" class="form-select">
              <option :value="true">Sí</option>
              <option :value="false">No</option>
            </select>
          </div>
          <div class="col-12 d-flex gap-2">
            <button class="btn btn-dark" :disabled="saving">{{ saving ? 'Guardando...' : submitLabel }}</button>
            <button class="btn btn-outline-secondary" type="button" @click="resetForm">Limpiar</button>
          </div>
        </form>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead>
            <tr>
              <th>ID</th>
              <th>Número</th>
              <th>Inicio</th>
              <th>Fin</th>
              <th>Activo</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="6" class="text-center text-muted py-4">Cargando...</td>
            </tr>
            <tr v-else-if="!rows.length">
              <td colspan="6" class="text-center text-muted py-4">No hay timbrados registrados.</td>
            </tr>
            <tr v-for="row in rows" :key="row.timbrado_id">
              <td>{{ row.timbrado_id }}</td>
              <td>{{ row.numero_timbrado || row.timbrado }}</td>
              <td>{{ formatDate(row.fecha_inicio || row.fec_ini) }}</td>
              <td>{{ formatDate(row.fecha_fin || row.fec_fin) }}</td>
              <td>{{ row.activo ? 'Sí' : 'No' }}</td>
              <td class="text-end">
                <button class="btn btn-outline-dark btn-sm" @click="editRow(row)">Editar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
import maintenanceFiscalService from '@/services/maintenanceFiscalService'

const loading = ref(false)
const saving = ref(false)
const rows = ref([])
const form = reactive({
  timbrado_id: null,
  numero_timbrado: '',
  fecha_inicio: '',
  fecha_fin: '',
  activo: true
})

const submitLabel = computed(() => form.timbrado_id ? 'Actualizar timbrado' : 'Crear timbrado')

function formatDate(value) {
  return value ? String(value).slice(0, 10) : '—'
}

function resetForm() {
  form.timbrado_id = null
  form.numero_timbrado = ''
  form.fecha_inicio = ''
  form.fecha_fin = ''
  form.activo = true
}

function editRow(row) {
  form.timbrado_id = row.timbrado_id
  form.numero_timbrado = row.numero_timbrado || row.timbrado || ''
  form.fecha_inicio = formatDate(row.fecha_inicio || row.fec_ini).replace('—', '')
  form.fecha_fin = formatDate(row.fecha_fin || row.fec_fin).replace('—', '')
  form.activo = row.activo !== false
}

async function loadRows() {
  loading.value = true
  try {
    rows.value = await maintenanceFiscalService.listTimbrados() || []
  } catch (error) {
    console.error('Error cargando timbrados', error)
    window.alert(error.userMessage || 'No se pudieron cargar los timbrados')
  } finally {
    loading.value = false
  }
}

async function saveRow() {
  saving.value = true
  try {
    const payload = {
      numero_timbrado: form.numero_timbrado,
      fecha_inicio: form.fecha_inicio || null,
      fecha_fin: form.fecha_fin || null,
      activo: form.activo
    }
    if (form.timbrado_id) {
      await maintenanceFiscalService.updateTimbrado(form.timbrado_id, payload)
    } else {
      await maintenanceFiscalService.createTimbrado(payload)
    }
    resetForm()
    await loadRows()
  } catch (error) {
    console.error('Error guardando timbrado', error)
    window.alert(error.userMessage || 'No se pudo guardar el timbrado')
  } finally {
    saving.value = false
  }
}

onMounted(loadRows)
</script>
